import PropTypes from 'prop-types';
import { useState } from 'react';

import { Box } from '@hivebrite/design-system/Box';
import { DropdownButton } from '@hivebrite/design-system/Dropdown';
import { ScreenReadersContent } from '@hivebrite/design-system/ScreenReadersContent';
import { useIsMounted } from '@hivebrite/react-hooks';

import useInputAndDropdownTheme from 'hb-react/shared/hooks/theme/useInputAndDropdownTheme';

const MemberActionsButton = ({
  following,
  onUnfollow,
  onUpdateSettings,
  topicClosed,
}) => {
  const inputAndDropdownTheme = useInputAndDropdownTheme();
  const isMounted = useIsMounted();
  const [isLoading, setIsLoading] = useState(false);

  const getOptionLabel = (key, label) => (
    <>
      {label}
      <ScreenReadersContent>
        {s__('Topics|Notifications')}
        {isOptionActive(key) && s__('Accessibility|, Selected')}
      </ScreenReadersContent>
    </>
  );

  const isOptionActive = (type) => following.group_activity_frequency === type;
  const buildOption = (label, type) => ({
    dataTestId: isOptionActive(type)
      ? 'member-action-selected'
      : 'member-action-not-selected',
    selected: isOptionActive(type),
    label: getOptionLabel(type, label),
    onClick: () => {
      onUpdateSettings(following, {
        group_activity_frequency: type,
      });
    },
  });

  const notificationOptions = [
    {
      label: __('None'),
      type: 'none',
    },
    {
      label: __('Instant'),
      type: 'instant',
    },
    {
      label: __('Daily'),
      type: 'daily',
    },
  ];

  const leaveActionItems = !topicClosed
    ? [
        {
          label: I18n.t('web.groups.unfollow'),
          onClick: async () => {
            setIsLoading(true);
            try {
              await onUnfollow();
            } finally {
              isMounted() && setIsLoading(false);
            }
          },
        },
      ]
    : [];

  const actionsItems = [
    ...leaveActionItems,
    {
      render: () => (
        <Box
          px={3}
          pt={2}
          pb={1}
          font="body-semibold-asphalt"
          // Hardcode input theme color since it will be rendered on input theme BG
          color={inputAndDropdownTheme.color}
        >
          {s__('Topics|Notifications')}
        </Box>
      ),
    },
    ...notificationOptions.map(({ label, type }) => buildOption(label, type)),
    buildOption(__('Weekly'), 'weekly'),
  ];

  return (
    <DropdownButton
      items={actionsItems}
      dataTestId="members-actions-dropdown"
      title={s__('Accessibility|Leave or change notification settings')}
      isLoading={isLoading}
      position="left"
    >
      {I18n.t('web.groups.following')}
    </DropdownButton>
  );
};

MemberActionsButton.propTypes = {
  following: PropTypes.object,
  onUnfollow: PropTypes.func.isRequired,
  onUpdateSettings: PropTypes.func.isRequired,
};

export default MemberActionsButton;
